import React, { FC, useCallback } from 'react';
import OWTaskComponent from './OWTaskComponent';
import { doNothingPromise } from '../../thunks/fetch_utils';

const OWTaskFormComponent: FC<any> = ({
	retainTaskObject = false,
	associationDisabled,
	addGroupDisabled,
	value,
	onChange,
	notCheckable = true,
	timeZoneId = null,
}): React.ReactElement => {
	const onTasksChange = useCallback(
		(tasks) => {
			const sanitizedTasks = (tasks || []).filter((_) => !!_.title);
			onChange(
				sanitizedTasks.map((task, orderingId) => ({
					...(retainTaskObject && { ...task }),
					title: task.title,
					questionType: task.questionType,
					groupTitle: task.groupTitle,
					orderingId,
					siteSurveyTemplateIds: task.siteSurveyTemplateIds || undefined,
				}))
			);
		},
		[onChange, retainTaskObject]
	);

	return (
		<OWTaskComponent
			existingTasks={value}
			isAllowedToEdit
			bulkUpdateTasks={doNothingPromise}
			bulkDeleteTasks={doNothingPromise}
			onTaskEdit={doNothingPromise}
			onTaskDelete={doNothingPromise}
			timeZoneId={timeZoneId}
			onTasksChange={onTasksChange}
			notCheckable={notCheckable}
			isPMTemplate
			associationDisabled={associationDisabled}
			addGroupDisabled={addGroupDisabled}
		/>
	);
};

export default OWTaskFormComponent;
